import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { SocialProof } from "./components/SocialProof";
import { AboutSection } from "./components/AboutSection";
import { SpecialtiesSection } from "./components/SpecialtiesSection";
import { InvisalignSection } from "./components/InvisalignSection";
import { WhiteningSection } from "./components/WhiteningSection";
import { CTASection } from "./components/CTASection";
import { LocationSection } from "./components/LocationSection";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import GuiaClareamento from "./pages/GuiaClareamento";

const HomePage = () => (
  <>
    <Header />
    <HeroSection />
    <SocialProof />
    <AboutSection />
    <SpecialtiesSection />
    <InvisalignSection />
    <WhiteningSection />
    <CTASection />
    <LocationSection />
    <Footer />
    <WhatsAppButton />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/guia-clareamento" element={<GuiaClareamento />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
